import {
  IncomeDTO,
  IncomeFrequency,
  IncomeModel,
  IncomeType,
  OwnerModelDTO,
} from '../../api/useIncomeQuery';
import { getDefaultCustomBucketIndex } from '../../utils/getDefaultCustomBucketIndex';

export type FRA = 'FRA';

export interface UpsertIncomeDTO extends SocialSecurityFormValues {
  clientId: string;
  id: string | null;
  incomeType: IncomeType;
  useFra: boolean | null;
}

export interface SocialSecurityFormValues {
  earner: string;
  amount: number | null;
  startAge: number | FRA | null | undefined;
  currentlyReceivingBenefits: boolean;
  incomeFrequency: IncomeFrequency | null;
  useFra: boolean | null;
  orionManagementStyleId: number | null;
  customBucketIndex: number | null;
  ownerModel: OwnerModelDTO[];
}

const defaultValues = {
  amount: null,
  currentlyReceivingBenefits: false,
  useFra: null,
  startAge: null,
  orionManagementStyleId: null,
  customBucketIndex: null,
};

export const dataToForm = (
  income: IncomeModel | null,
  data: IncomeDTO,
): SocialSecurityFormValues => {
  const { Options: options } = data;

  if (!income) {
    return {
      ...defaultValues,
      earner: options.OwnerOptions.People[0].Name,
      incomeFrequency: options.IncomeFrequencyOptions[1].value,
      ownerModel: [
        {
          Id: null,
          Name: options.OwnerOptions.People[0].Name,
          OwnerType: 0,
          Percentage: 1,
        },
      ],
    };
  }

  return {
    earner: income.Earner,
    amount: income.Amount,
    currentlyReceivingBenefits: income.CurrentlyReceivingBenefits,
    incomeFrequency: income.IncomeFrequency,
    useFra: income.UseFra,
    startAge: income.UseFra ? 'FRA' : income.StartAge,
    orionManagementStyleId: income.OrionManagementStyleId,
    customBucketIndex: getDefaultCustomBucketIndex({
      isAssetBucketingByManagementStyle: options.AssetBucketingByManagementStyle,
      customBucketIndex: income.CustomBucketIndex,
      orionManagementStyleId: income.OrionManagementStyleId,
      managementStylesOptions: options.ManagementStyles,
    }),
    ownerModel: income.OwnerModel,
  };
};

export const receivingBenefitsOptions = [
  {
    value: true,
    label: 'Yes',
  },
  {
    value: false,
    label: 'No',
  },
];

export const MIN_RETIREMENT_YEAR = 1952;
export const MAX_RETIREMENT_YEAR = 1960;
